// extracted by mini-css-extract-plugin
export default {"MyRecipes":"MyRecipes_MyRecipes__7fmDt","my_recipes__list":"MyRecipes_my_recipes__list__T2J6c","my_recipe":"MyRecipes_my_recipe__igGPP"};